export const ALLOWED_GLOBAL_BASE_NAMES = ['/pl/app', '/en/app', '/uk/app']
export const ALLOWED_CREATOR_BASE_NAMES = [
    '/pl/kreator',
    '/en/creator',
    '/uk/creator',
]
export const ALLOWED_CREATOR_ACCOMMODATION_BASE_NAMES = [
    '/pl/kreator-zakwaterowanie',
    '/en/creator-accommodation',
    '/uk/creator-accommodation',
]
export const ALLOWED_SELFCARE_BASE_NAMES = [
    '/pl/zarzadzaj-zamowieniem',
    '/en/manage-order',
    '/uk/manage-order',
]
export const ALLOWED_UNLIMITED_CARD_BASE_NAMES = [
    '/pl/karta-caloroczna',
    '/en/unlimited-card',
    '/uk/unlimited-card',
]
export const ALLOWED_UNLIMITED_RENEW_BASE_NAMES = [
    '/pl/odnow-karte',
    '/en/renew-card',
    '/uk/renew-card',
]
export const ALLOWED_VOUCHERS_BASE_NAMES = [
    '/pl/kreator-vouchery',
    '/en/vouchers-creator',
    '/uk/vouchers-creator',
]
